module.exports = __webpack_public_path__ + "img/y.4df47eb5.png";